export interface LmiCategory {
  name: string;
  i18nKey: string;
  categoryId: string;
}

export const LMI_CATEGORIES: LmiCategory[] = [
  { name: 'Listings', i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.LISTINGS', categoryId: 'listings' },
  { name: 'Social', i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.SOCIAL', categoryId: 'social' },
  { name: 'Reputation', i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.REPUTATION', categoryId: 'reputation' },
  { name: 'SEO', i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.SEO', categoryId: 'seo' },
  { name: 'Website', i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.WEBSITE', categoryId: 'website' },
  { name: 'Advertising', i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.ADVERTISING', categoryId: 'advertising' },
  {
    name: 'Content and Experience',
    i18nKey: 'FRONTEND.STORE.LMI_CATEGORIES.CONTENT_AND_EXPERIENCE',
    categoryId: 'content_and_experience',
  },
];

export const LMI_CATEGORY_MAP = LMI_CATEGORIES.reduce((previous, current) => {
  previous[current.categoryId] = current;
  return previous;
}, {});

export const LMI_CATEGORIES_BY_NAME = LMI_CATEGORIES.reduce((previous, current) => {
  previous[current.name] = current;
  return previous;
}, {});
